import { render, staticRenderFns } from "./EditPolice.vue?vue&type=template&id=495c3438"
import script from "./EditPolice.vue?vue&type=script&lang=js"
export * from "./EditPolice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports